import { useRef } from 'react'
import { ChevronUpIcon, ChevronDownIcon } from '@shipt/design-system-icons'
import styled from 'styled-components'
import { TextButton } from '@shipt/design-system-buttons'
import { Body } from '@shipt/design-system-typography'
import { Box } from '@shipt/design-system-layouts'

interface ViewMoreButtonProps {
  isShowingMore: boolean
  onClick: () => void
}

export const ViewMoreButton = ({ isShowingMore, onClick, ...restProps }: ViewMoreButtonProps) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null)

  const handleOnClick = () => {
    if (!isShowingMore) {
      buttonRef.current?.blur()
    }
    onClick()
  }

  return (
    <Box
      marginLeft={{ base: 'sm', md: 0 }}
      padding={{ base: ['sm', 0, 'sm', 'xl'], md: [0, 0, 0, 'xl'] }}
    >
      <ActionButton
        ref={(ref) => {
          buttonRef.current = ref
        }}
        onClick={handleOnClick}
        {...restProps}
      >
        <Body>{isShowingMore ? 'View less' : 'View more'}</Body>
        {isShowingMore ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </ActionButton>
    </Box>
  )
}

const ActionButton = styled(TextButton)`
  & svg {
    height: 1rem;
    width: 1rem;
  }
`
